import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { Environment } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import {
  eduProductIdSelector,
  isBATenantSelector,
  isBusinessAssistUXEnabledSelector,
  isNonAgaveSelector,
  isTeamsSelector,
  showSectionHeaderSelector,
} from '../../app/selectors/contactUsSelector';
import { FormHeader } from '../presentationalComponents/FormHeader';
import {
  isUnifiedPremierSelector,
  isUnifiedEnterprisePremierSelector,
  isNonUnifiedPremierSelector,
  isPremierTenantSelector,
} from '../reduxUpdater/selectors/globalStateSelectors';
import { getFormHeaderStyles } from '../styles/formHeaderStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    appName: state.GlobalState.sourceApp || state.GlobalState.appVer,
    runningInSoc: state.GlobalState.environment === Environment.SOC,
    isNonAgave: isNonAgaveSelector(state),
    isUnifiedPremier: isUnifiedPremierSelector(state),
    isUnifiedEnterprisePremier: isUnifiedEnterprisePremierSelector(state),
    isNonUnifiedPremier: isNonUnifiedPremierSelector(state),
    isPremierTenantEnabled: isPremierTenantSelector(state),
    isSMCExperiment: state.ContactState.SharedState.isSMCExperiment,
    isBATenant: isBATenantSelector(state),
    showSectionHeader: showSectionHeaderSelector(state),
    isBusinessAssistUXEnabled: isBusinessAssistUXEnabledSelector(state),
    eduProductId: eduProductIdSelector(state),
    isTeams: isTeamsSelector(state),
    sourceApp: state.GlobalState.sourceApp,
  };
};

export const FormHeaderContainer = connect(mapStateToProps)(styled(FormHeader, getFormHeaderStyles));
